export default class Cart {
   constructor(){
      $('.ordernote--toggle').click(function(e){
         e.preventDefault();
         if(!$('.ordernote--message').is(':visible')){
            setTimeout(function(){
               var val = $('.ordernote--message--area').val();
               $('.ordernote--message--area').focus();
               $('.ordernote--message--area').get(0).setSelectionRange(val.length, val.length);
            }, 320);
         }
         $('.ordernote--message').toggle(300);
      });
      
      if($('.ordernote--message--area').length>0){
         if($('.ordernote--message--area').val().length>0) {
            $('.ordernote--message').show();
         }
      }
      
      $('.ordernote--message--area').unbind('keyup').on('keyup', function(){
         var val = $(this).val();
         clearTimeout(window.cartNoteTimeout);
         $('.checkout-button').addClass('disabled');
         window.cartNoteTimeout = setTimeout(function(){
            fetch(window.routes.cartUrl + '/update.js', {
               body: JSON.stringify({ note: val }),
               credentials: 'same-origin',
               method: 'POST',
               headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
               }
            }).then(function(response){
               $('.checkout-button').removeClass('disabled');
               console.log(response);
            });
         }, 2000);
      });
   }
}